export default __webpack_public_path__ + "assets/icons/eye-close.ca7e6ea5.svg";